import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useToast } from "../Toast";
import { isWeekend } from "@/utils/dateTime";
import { DateInput } from "../DateInput";
const WEEKEND_MESSAGE = "Commencement date cannot fall on a weekend.";
export const CommencementDateInput = ({ value, onChange, className, id, name, disabled, disableWeekends = true, "data-testid": dataTestId, }) => {
    const toast = useToast();
    const handleChange = useCallback((next) => {
        if (disableWeekends && isWeekend(next)) {
            toast.error(WEEKEND_MESSAGE, 4000);
            return;
        }
        onChange(next);
    }, [onChange, toast, disableWeekends]);
    return (_jsx(DateInput, { className: className, id: id, name: name, value: value, onChange: handleChange, disabled: disabled, "data-testid": dataTestId, onInvalid: () => toast.error("Please enter a valid date.", 4000) }));
};
